var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLucideCheckCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.917 12.0418V13.0001C22.9157 15.2464 22.1883 17.4321 20.8433 19.2312C19.4984 21.0303 17.6079 22.3464 15.4538 22.9833C13.2997 23.6202 10.9974 23.5438 8.89036 22.7653C6.78329 21.9869 4.9843 20.5481 3.7617 18.6637C2.5391 16.7793 1.9584 14.5502 2.1062 12.3088C2.254 10.0674 3.12238 7.93379 4.58183 6.22623C6.04128 4.51867 8.0136 3.32864 10.2046 2.8336C12.3957 2.33856 14.6881 2.56505 16.7399 3.47928",
    stroke: "url(#paint0_linear_110_706)",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9167 4.66641L12.5 15.0935L9.375 11.9685",
    stroke: "url(#paint1_linear_110_706)",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_110_706",
    x1: 2.08362,
    y1: 12.9942,
    x2: 22.917,
    y2: 12.9942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0050AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0391E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_110_706",
    x1: 9.375,
    y1: 9.87996,
    x2: 22.9167,
    y2: 9.87996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0050AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0391E8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLucideCheckCircle);
export default __webpack_public_path__ + "static/media/lucide_check-circle.5761b411.svg";
export { ForwardRef as ReactComponent };